// File: frontend/src/components/common/TextInput.js

import React, { useState } from 'react';
import styles from './TextInput.module.css';

const TextInput = ({
  value = '',
  onChange,
  label,
  name,
  placeholder,
  required = false,
  error = null,
  disabled = false,
  type = 'text',
  autoComplete // ✅ Accept autocomplete prop
}) => {
  const [isFocused, setIsFocused] = useState(false);
  
  const handleTextChange = (e) => {
    if (onChange) {
      onChange(name, e.target.value);
    }
  };
  
  // ✅ Auto-detect autocomplete based on name
  const getAutoComplete = () => {
    if (autoComplete) return autoComplete;
    
    if (name === 'first_name') return 'given-name';
    if (name === 'last_name') return 'family-name';
    if (name === 'email_address') return 'email';
    
    return 'off';
  };
  
  return (
    <div className={styles.textInputContainer}>
      {label && (
        <label className={styles.label}>
          {label}
          {required && <span className={styles.required}>*</span>}
        </label>
      )}
      
      <div className={`${styles.inputGroup} ${error ? styles.hasError : ''} ${isFocused ? styles.focused : ''}`}>
        <input
          type={type}
          name={name}
          className={styles.textInput}
          placeholder={placeholder}
          value={value}
          onChange={handleTextChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          disabled={disabled}
          required={required}
          autoComplete={getAutoComplete()} // ✅ Enable autofill
        />
      </div>
      
      {error && <div className={styles.errorMessage}>{error}</div>}
    </div>
  );
};

export default TextInput;